import React, { useState } from "react";
import ParagraphTag from "../reusebale/Paragraph";
import LabelTag from "../reusebale/label";
import ButtonTag from "../reusebale/button";
import BaseUrl from "../../constants/BaseUrl"
import { ShowError, ShowSuccess } from "../../utils/ToasFunction";
import MyLoader from "../../../src/component/reusebale/MyLoader"
import { useSelector } from 'react-redux'
const TutorialPopup = ({ onFormSubmit, onBack, refreshList }) => {
  const [formFields, setFormFields] = useState({
    title: "",
    link: "",
    role: "Landlord"
  })

  const [loading, setLoading] = useState(false)
  const { loginSuccess, } = useSelector(
    (state) => state.auth
  );
  const CreateRequestHandler = () => {
    setLoading(true)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      "title": formFields.title,
      "link": formFields.link,
      "role": formFields.role
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${BaseUrl}api/tutorials/createTutorial`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setLoading(false)
          setFormFields({
            ...formFields,
            title: "",
            link: "",
            role: ""
          })
          ShowSuccess("Request created successfully")
          refreshList()
          onBack()

        } else {
          setLoading(false)
          ShowError("Oops! something went wrong")
        }
      })
      .catch((error) => console.error(error));

  }

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[30%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 lg:py-5 rounded-xl justify-center items-center flex flex-col">
          <div>
            <ParagraphTag
              content="Create New"
              classes={`text-darkColor font-popinsSemiBold text-base `}
            />
          </div>
          <div className="pt-2 w-[90%] mx-auto">
            <LabelTag
              isStaric={false}
              name="Title"
              classes="!text-xs !font-popinsMedium"
            />
            <input
              value={formFields.title}
              onChange={(e) => {
                setFormFields({
                  ...formFields,
                  title: e.target.value
                })
              }}

              type="text"
              placeholder="Enter title here"
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
            />
          </div>
          <div className="pt-2 w-[90%] mx-auto">
            <LabelTag
              isStaric={false}
              name="Link"
              classes="!text-xs !font-popinsMedium"
            />
            <input

              value={formFields.link}
              onChange={(e) => {
                setFormFields({
                  ...formFields,
                  link: e.target.value
                })
              }}

              type="text"
              placeholder="Enter link here."
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
            />
          </div>
          <div className="pt-2 w-[90%] mx-auto">
            <LabelTag
              isStaric={false}
              name="User Role"
              classes="!text-xs !font-popinsMedium"
            />
            <select
              value={formFields.role}
              onChange={(e) => {
                setFormFields({
                  ...formFields,
                  role: e.target.value
                })
              }}
              className="block w-full px-3 py-2 border border-gray-300 rounded-sm shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor sm:text-sm bg-bgColor"
            >

              <option>Landlord</option>
              <option>Tenant</option>
              <option>SupportStaff</option>
            </select>
          </div>
          {loading ? <div className="mt-4">
            <MyLoader />
          </div> : <div className="w-full px-2">

            <ButtonTag
              onSubmit={() => {
                function isValidYouTubeUrl(url) {
                  const regex = String(url).includes("youtube.com")
                  if (regex) {
                    return true
                  } else {
                    return false
                  }

                }
                if (formFields.title === "") {
                  ShowError("Title cannot be empty")
                } else if (formFields.link === "") {
                  ShowError("Link cannot be empty")
                } else if (!isValidYouTubeUrl(formFields.link)) {
                  ShowError("Only youtube link is supported")
                } else {

                  CreateRequestHandler()
                }
              }}
              name="Submit"
              classes="text-sm bg-themeColor hover:bg-themeColor/90 mt-5 text-center  text-white"
            />
            <p
              className="text-darkColor pt-2 flex item-center justify-center cursor-pointer font-popinsMedium text-sm"
              onClick={onBack}
            >
              Close
            </p>
          </div>}

        </div>
      </section>
    </main>
  );
};

export default TutorialPopup;
